




































































import Vue, { PropOptions } from 'vue';
import { NOC } from '@/class';
import SideMenuBase from '@/components/util/SideMenuBase.vue';
import SimpleList from '@/components/util/SimpleList.vue';
import SelectBoxV3, { IOption } from '@/components/util/SelectBoxV3.vue';
import * as Talert from '@/class/models/typed/alert';

export interface ISideMenuItem {
  itemID: string;
  groupingID: number;
  parentID?: number;
  name: string;
  path: string;
  only?: boolean;
}

export default Vue.extend({
  name: 'SideMenuAlert',
  components: {
    SideMenuBase,
    SimpleList,
    SelectBoxV3,
  },
  props: {
    alertList: Array as PropOptions<Talert.INewsAlert[]>,
    showDetaile: Boolean,
    initialSideMenu: String,
  },
  watch: {
    initialSideMenu: {
      immediate: true,
      handler() {
        this.setSideMenu = this.initialSideMenu;
        if (this.initialSideMenu) {
          const match = this.initialSideMenu.match(/\d+/);
          if (match) {
            this.selectedItem = match[0];
          }
        }
      },
    },
  },
  data() {
    return {
      sampleList: [
        { itemID: 1, name: '通知設定', only: true },
        { itemID: 6, name: '月間レポート', only: true },
        { groupingID: 99, name: 'すべての通知', parentID: 0 },
        // {itemID: 2, name: '長時間残業通知', groupingID: 99},
        { itemID: 3, name: '36協定通知', groupingID: 99 },
        { itemID: 4, name: '勤務間インターバル通知', groupingID: 99 },
        { itemID: 5, name: '禁止アプリ通知', groupingID: 99 },
        { itemID: 7, name: '異常操作回数通知', groupingID: 99 },
      ],
      tabList: [
        { itemID: 6, name: '月間レポート', groupingID: 99 },
        { groupingID: 99, name: 'すべての通知', parentID: 0 },
        // {itemID: 2, name: '長時間残業通知', groupingID: 99},
        { itemID: 3, name: '36協定通知', groupingID: 99 },
        { itemID: 4, name: '勤務間インターバル通知', groupingID: 99 },
        { itemID: 5, name: '禁止アプリ通知', groupingID: 99 },
        { itemID: 7, name: '異常操作回数通知', groupingID: 99 },
      ],
      setSideMenu: 'c1',
      selectedItem: '0',
      nowPage: 0 as number,
      isSideMenuVisible: true,
    };
  },
  methods: {
    getParentID(v: ISideMenuItem) {
      return v.groupingID;
    },
    getChildID(v: ISideMenuItem) {
      return v.itemID;
    },
    getItemText(v: ISideMenuItem) {
      return v.name;
    },
    toggleSideMenu() {
      // サイドメニューの表示/非表示を切り替えるメソッド
      this.isSideMenuVisible = !this.isSideMenuVisible;
    },
    handleResize() {
      if (window.innerWidth < 650) {
        this.isSideMenuVisible = false;
      }
    },
    selectValue(value: string) {
      // console.log('selectValue', value);
      this.selectedItem = String(value);
      this.setSideMenu = `c${value}`;

      if (this.selectedItem === '0' || this.selectedItem === '99') {
        this.selectedItem = '99';
        this.setSideMenu = 'p99';
      }
      // 親コンポーネントにthis.selectedItemを渡して、親コンポーネントのthis.selectedItemを更新
      this.$emit('changeItem', this.selectedItem);
    },
    onClickEdit(edit: boolean) {
      // SP表示で設定ボタン押下
      let path = '/setting/alert';
      path += edit ? `?edit=${edit}` : '';
      // path += `?edit=${edit}`;
      this.$emit('pushPath', path);
      this.$router.push(path, () => {});
    },
    navigateToSettings() {
      // sp-tab用の設定ボタンのメソッド
      const path = '/setting/alert';
      this.$router.push(path, () => {});
      this.isSideMenuVisible = !this.isSideMenuVisible;
    },
    clickItem(v: any) {
      // console.log('clickItem', v);
      if (this.setSideMenu === 'c1') {
        // 通知設定から操作
        if (v.parentID != null) {
          if (v.parentID === 0) {
            // すべての通知
            const path = '/alert?cat=99';
            this.$router.push(path, () => {});
          }
        } else {
          if (v.itemID === 1) {
            // 通知設定: 画面が変わらないので処理なし
            // this.mode = NOC.SETTING.MODE.NORMAL;
            // this.selectedItem = '1';
            // this.setSideMenu = `c${v.itemID}`;
            this.isSideMenuVisible = !this.isSideMenuVisible;
          } else {
            const path = `/alert?cat=${v.itemID}`;
            this.$router.push(path, () => {});
          }
        }
      } else {
        // アラート一覧から操作
        if (v.parentID != null) {
          if (v.parentID === 0) {
            // すべての通知
            this.$emit('clickItem', v);
            // this.mode = NOC.SETTING.MODE.LIST;
            this.setSideMenu = `p${v.groupingID}`;
            this.isSideMenuVisible = !this.isSideMenuVisible;
          }
        } else {
          if (v.itemID === 1) {
            // 通知設定（PC表示で押下）
            this.onClickEdit(false);
            // this.mode = NOC.SETTING.MODE.NORMAL;
            // this.selectedItem = '1';
            // this.setSideMenu = `c${v.itemID}`;
          } else {
            this.$emit('clickItem', v);
            // this.mode = NOC.SETTING.MODE.LIST;
            this.selectedItem = String(v.itemID);
            this.setSideMenu = `c${v.itemID}`;
            this.isSideMenuVisible = !this.isSideMenuVisible;
          }
        }
        this.selectValue(this.selectedItem);
      }
    },
    clickParent(v: any) {
      // this.$emit('clickItem');
      // this.mode = NOC.SETTING.MODE.LIST;
      const path = '/alert?cat=99';
      this.$router.push(path, () => {});
      this.selectedItem = String(v.groupingID);
      this.isSideMenuVisible = !this.isSideMenuVisible;
    },
    selectAlertType(value: string) {
      // 引数に入ってきたselectedItemをNOC.ALERTの値に変換
      if (value === '2') {
        value = '1';
      } else if (value === '3') {
        value = '10';
      } else if (value === '4') {
        value = '2';
      } else if (value === '5') {
        value = '90';
      } else if (value === '6') {
        value = value;
      } else if (value === '0') {
        value = '99';
      } else if (value === '1') {
        value = '99';
      }

      let newList = this.alertList.map(item => ({ ...item }));
      newList = newList.filter(f => String(f.type) === value);

      if (value === '99') {
        return this.alertList;
      } else {
        return newList;
      }
    },
    openDetaile(data: Talert.INewsAlert, key: any) {
      if (this.setSideMenu === 'c1') {
        // 通知設定
        const path = `/alert?cat=${this.selectedItem}&id=${data.alertID}`;
        this.$router.push(path, () => {});
      } else {
        // アラート一覧
        this.$emit('openDetaile', { data, key });
      }
    },
    currentPage(value: number) {
      this.nowPage = value;
    },
    checkRoutePath() {
      this.isSideMenuVisible = this.$route.fullPath === '/alert';
    },
  },
  computed: {
    // チェックボックスの選択肢(SPのみ使用)
    ALERT_OPTIONS(): IOption[] {
      return [
        { value: 6, text: '月間レポート' },
        { value: 0, text: 'すべての通知' },
        // {value: 2, text: '長時間残業通知'},
        { value: 3, text: '36協定通知' },
        { value: 4, text: '勤務間インターバル通知' },
        { value: 5, text: '禁止アプリ通知' },
        { value: 7, text: '異常操作回数通知' },
      ];
    },
    // アラートの種類
    alertCategories(): NOC.NEWS.ICategory[] {
      return [
        {
          title: 'すべての通知',
          type: '99',
          icon: 'fa-info-circle',
          background: '#FFE8E3',
          color: '#F43308',
        },
        {
          title: '残業',
          type: '1',
          icon: 'fa-info-circle',
          background: '#FFE8E3',
          color: '#F43308',
        },
        {
          title: '36協定',
          type: '10',
          icon: 'fa-info-circle',
          background: '#FFE8E3',
          color: '#F43308',
        },
        {
          title: 'インターバル',
          type: '2',
          icon: 'fa-info-circle',
          background: '#FFE8E3',
          color: '#F43308',
        },
        {
          title: '禁止アプリ',
          type: '90',
          icon: 'fa-info-circle',
          background: '#FFE8E3',
          color: '#F43308',
        },
        {
          title: 'レポート',
          type: '100',
          icon: 'fa-info-circle',
          background: '#DCE5F8',
          color: '#182863',
        },
        {
          title: '異常操作',
          type: `${NOC.ALERT.TYPE.IRREGULAR_OP}`,
          icon: 'fa-info-circle',
          background: '#DCE5F8',
          color: '#182863',
        },
      ];
    },
  },
  created() {
    this.checkRoutePath();
    // 画面サイズ変更時にhandleResizeを呼び出す
    window.addEventListener('resize', this.handleResize);
    // 初回チェック
    this.handleResize();
  },
  beforeRouteUpdate() {
    // URLをチェック
    this.checkRoutePath();
  },
  beforeDestroy() {
    // イベントリスナーを削除する
    window.removeEventListener('resize', this.handleResize);
  },
});
